import 'Styles/main.scss';

import Swiper from '../components/swiper';
import Overlay from '../components/overlay';
import Accor from '../components/accor';

// Global Vue Directory
import Header from '../components/header';
import MiniCart from '../vue/cart/mini-cart';

Swiper();
Overlay();
Accor();
Header();
MiniCart();
